import { IconName } from '@outlaw/icons';
import { PartnerApp } from './partner';

export enum SocialMediaPlatform {
  Instagram = 'instagram',
  YouTube = 'youtube',
  Spotify = 'spotify',
  Twitter = 'twitter',
  TikTok = 'tiktok',
  ArgoTest = 'argo.ot4.dev', // only for testing
  Argo = 'web.watchargo.com',
  Brandon = 'itsbrandontv.live',
  BrandonTest = 'brandon.ot4.dev',
  Flixsnip = 'flixsnip.com',
}

export const PartnerPlatforms = [
  SocialMediaPlatform.Argo,
  SocialMediaPlatform.ArgoTest,
  SocialMediaPlatform.Brandon,
  SocialMediaPlatform.BrandonTest,
];

export const PartnerPlatformsMap: Map<SocialMediaPlatform, PartnerApp> = new Map([
  [SocialMediaPlatform.Argo, PartnerApp.ARGO],
  [SocialMediaPlatform.Brandon, PartnerApp.BRANDON],
  [SocialMediaPlatform.ArgoTest, PartnerApp.ARGO],
  [SocialMediaPlatform.BrandonTest, PartnerApp.BRANDON],
]);

export const SOCIAL_MEDIA_ICONS: Record<SocialMediaPlatform, IconName | null> = {
  [SocialMediaPlatform.Instagram]: 'logoInstagram',
  [SocialMediaPlatform.YouTube]: 'logoYoutube',
  [SocialMediaPlatform.Spotify]: 'logoSpotify',
  [SocialMediaPlatform.Twitter]: 'logoX',
  [SocialMediaPlatform.TikTok]: 'logoTiktok',
  [SocialMediaPlatform.ArgoTest]: 'argo',
  [SocialMediaPlatform.Argo]: 'argo',
  [SocialMediaPlatform.Brandon]: 'logoBrandon',
  [SocialMediaPlatform.BrandonTest]: 'logoBrandon',
  [SocialMediaPlatform.Flixsnip]: null,
};

export const SOCIAL_MEDIA_ICON_SIZES: Record<SocialMediaPlatform, { width: number; height: number } | null> = {
  [SocialMediaPlatform.Instagram]: { width: 54, height: 16 }, // 84:25 scaled to h=16
  [SocialMediaPlatform.YouTube]: { width: 72, height: 16 },
  [SocialMediaPlatform.Spotify]: { width: 53, height: 16 }, // 80:24 scaled to h=16
  [SocialMediaPlatform.Twitter]: { width: 17, height: 16 },
  [SocialMediaPlatform.TikTok]: { width: 69, height: 16 },
  [SocialMediaPlatform.ArgoTest]: { width: 39, height: 16 },
  [SocialMediaPlatform.Argo]: { width: 39, height: 16 },
  [SocialMediaPlatform.Brandon]: { width: 35, height: 16 }, // 55:25 scaled to h=16
  [SocialMediaPlatform.BrandonTest]: { width: 35, height: 16 }, // 55:25 scaled to h=16
  [SocialMediaPlatform.Flixsnip]: null,
};
